import MonthlyHR from "./MonthlyHR";

export default function PaySlips() {
  return <MonthlyHR kind="payslips" />;
}
